<template>
  <a :href="href" class="button" @click="$emit('click')" :target="target">
    <slot></slot>
  </a>
</template>

<script>
  export default {
    name: 'ButtonLink',
    props: ['href', 'target']
  }
</script>

<style scoped>
  .button {
    border-radius: 4px;
    padding: 12px 16px;
    background: var(--accent);
    color: #fff;
    font-weight: 700;
    border: none;
    display: block;
    width: 100%;
    box-sizing: border-box;
    text-decoration: none;
    line-height: 1;
    text-align: center;
  }

  .button:hover, .button:active {
    background: #333;
  }
</style>
